import React from 'react';


class SelectedIntents extends React.Component {

  render() {
    const that=this;

    const selectedIntents=this.props.selectedIntents.map(function(intent){
      return <div className='selected-intent' key={intent.tag}>{intent.name}</div>;
    });

    return (
      <div className='selected-intents'>
        <div className='selected-intents-name'><span>{this.props.name}</span></div>
        {selectedIntents}
      </div>
    );
  }
}

export default SelectedIntents;
